<template>
  <RevButton
    :loading="isLoading"
    size="small"
    variant="secondary"
    @click="openRequest"
    @done="emit('opened')"
  >
    {{ i18n(translations.openRequest) }}
  </RevButton>
</template>

<script script setup lang="ts">
import { ref } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'

import translations from './OpenRequestButton.translations'

const props = defineProps<{
  customerRequestId: number
}>()

const isLoading = ref<boolean>(false)
const logger = useLogger()
const i18n = useI18n()
const $httpFetch = useHttpFetch()

const emit = defineEmits(['opened'])

const { openErrorToast, openSuccessToast } = useTheToast()

async function openRequest() {
  isLoading.value = true

  try {
    await $httpFetch('/bm/customer_request/:customerRequestId/merchant/open', {
      method: 'POST',
      pathParams: {
        customerRequestId: props.customerRequestId,
      },
    })

    emit('opened')
    openSuccessToast()
  } catch (err) {
    openErrorToast()

    const error = err as Error
    logger.error(error.message, {
      error,
      owners: ['bot-squad-seller-care-front'],
    })
  } finally {
    isLoading.value = false
  }
}
</script>
